import { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import CarlineLayout from '../components/CarlineLayout';

const Index = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If accessing /post/:id, redirect to /?post=:id for regular users
    // Preserve section query param for deep linking
    if (id) {
      const params = new URLSearchParams(location.search);
      const section = params.get('section');
      
      navigate(`/?post=${id}${section ? `&section=${section}` : ''}`, { replace: true });
    }
  }, [id, navigate, location.search]);

  return <CarlineLayout />;
};

export default Index;
